/* ---------------------------------------------------------------------------
   Onboarding-only Module Federation remotes
   - Injects remoteEntry.js only when onboarding loads a product the user can access
   - Shell vue.config.js does not declare these remotes (no eager remoteEntry fetch)
--------------------------------------------------------------------------- */

import appConfig from "@/lib/config/app-config";
import {
  loadRemoteContainer,
  getModuleFromContainer,
} from "./register-remote.js";

const ONBOARDING_MODULE_PATH = "./onboardingSteps";

/** Webpack container name on window — must match each remote's federation `name` */
const REMOTE_NAME_BY_PRODUCT = {
  marketing: "marketing",
  commerce: "maropost_commerce",
  service: "service",
};

function remoteEntryUrlForProduct(product) {
  const base =
    product === "marketing"
      ? appConfig.MARKETING_NEW_APPLICATION_URL
      : product === "commerce"
        ? appConfig.COMMERCE_APPLICATION_URL
        : product === "service"
          ? appConfig.SERVICE_APPLICATION_URL
          : "";
  if (!base || typeof base !== "string") return "";
  return `${base.replace(/\/$/, "")}/remoteEntry.js`;
}

/**
 * Loads the onboarding steps module from the product remote (script inject + container.get).
 * @param {'marketing'|'commerce'|'service'} product
 * @returns {Promise<{ ONBOARDING_STEPS?: unknown; default?: unknown } | null>}
 */
export async function loadOnboardingRemoteModule(product) {
  const remoteName = REMOTE_NAME_BY_PRODUCT[product];
  const remoteUrl = remoteEntryUrlForProduct(product);
  if (!remoteName || !remoteUrl) {
    return null;
  }

  const container = await loadRemoteContainer(remoteUrl, remoteName);
  const mod = await getModuleFromContainer(container, ONBOARDING_MODULE_PATH);
  return mod;
}
